import React, { useState, useContext } from "react";
import { useReactFlow } from "@xyflow/react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Tooltip } from "@mui/material";
import { useThemeContext } from "../../Theme/Theme";
import AddNodeContext from "../../contexts/AddNodeContext";

const DeleteEdgeButton = ({ edgeId, target }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { getEdge } = useReactFlow();
  const { onEdgesDelete } = useContext(AddNodeContext);
  const { mode } = useThemeContext();

  if (target && target.includes("exitNode")) {
    return null;
  }

  const handleDelete = (e) => {
    e.stopPropagation();
    const edge = getEdge(edgeId);
    onEdgesDelete([edge]);
  };

  return (
    <Tooltip title="Delete" placement="top">
      <Button
        onClick={handleDelete}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        variant="contained"
        size="small"
        sx={{
          height: 15,
          width: 15,
          minWidth: 15,
          maxWidth: 15,
          borderRadius: "4px",
          backgroundColor: mode === "dark" ? "grey.800" : "grey.300",
          color: "#aaa",
          padding: 0,
          border: `1px solid ${isHovered ? "#1976d2" : "transparent"}`,
          transition: "border-color 0.2s",
          "&:hover": {
            backgroundColor: mode === "dark" ? "grey.800" : "grey.300",
          },
        }}
      >
        <DeleteIcon
          sx={{
            fontSize: 10,
            color: "#aaa",
          }}
        />
      </Button>
    </Tooltip>
  );
};

export default DeleteEdgeButton;
